import { render } from "./CreateOrEditPriceChargeModal.vue?vue&type=template&id=8111e410&ts=true"
import script from "./CreateOrEditPriceChargeModal.vue?vue&type=script&lang=ts"
export * from "./CreateOrEditPriceChargeModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__